import { provideApolloClient } from '@vue/apollo-composable'
import { createApolloClient } from '~/composables/createApolloClient/index'

export function apolloClient() {
    const apolloClient = createApolloClient()

    provideApolloClient(apolloClient)
}